<!-- <div *ngIf="isLoading | async" class="overlay">
  <div>
    <img src="/assets/img/spin2.gif" width="100" height="100" />
  </div>
</div> -->
<mat-progress-bar [ngClass]="{ 'loading': isLoading }" *ngIf="isLoading | async" [ngStyle]="{'--after-width': width + '%' , 'background-color': background}"  mode="determinate"  value="80" [mode]="mode"></mat-progress-bar>
